import React, { useEffect, useState } from 'react';
import {
    EmailShareButton,
    FacebookShareButton,
    TwitterShareButton,
} from 'react-share';
import { EmailIcon, FacebookIcon, TwitterIcon } from 'react-share';
import CopyToClipboard from './CopyToClipboard.jsx';
import common from '../../common/common.js';

import './Share.scss';

const Share = (props) => {
    let timeout;

    const showIcons = (e) => {
        const icons = document.querySelector('.share-container--icons');
        e.currentTarget.style.opacity = '0';

        setTimeout(() => {
            icons.style.transform = 'scaleX(1)';
        }, 500);

        clearTimeout(timeout);
        timeout = setTimeout(() => {
            icons.style.transform = 'scaleX(0)';
            setTimeout(() => {
                document.querySelector(
                    '.share-container--share'
                ).style.opacity = '1';
            }, 500);
        }, 5000);
    };

    const rootUrl = common.getSiteUrl(props.virtualdir);
    return (
        <div className='share-container'>
            <div className='share-container--share' onClick={showIcons}>
                <img src={`${rootUrl}/Content/img/share.svg`} />
            </div>
            <div className='share-container--icons'>
                <FacebookShareButton
                    className='share-container--icon facebook'
                    url={window.location.toString()}>
                    <FacebookIcon size={30} round={true} />
                </FacebookShareButton>
                <TwitterShareButton
                    className='share-container--icon twitter'
                    url={window.location.toString()}>
                    <TwitterIcon size={30} round={true} />
                </TwitterShareButton>
                <EmailShareButton
                    className='share-container--icon email'
                    url={window.location.toString()}
                    openShareDialogOnClick={true}>
                    <EmailIcon size={30} round={true} />
                </EmailShareButton>
                <CopyToClipboard url={window.location.toString()} />
            </div>
        </div>
    );
};

export default Share;
